import React, { useRef, useEffect, useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useRouter } from 'next/router';
import Text from '../Typography/Text';
import IconButton from '~/src/components/Mui/IconButton';
import ShoppingBasket from '~/src/components/Mui/ShoppingBasket';
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';
import getCartNbProducts from '~/src/lib/getCartNbProducts';

import { useScrollPosition } from '@n8tb1t/use-scroll-position';
import ChevronIcon from '@mui/icons-material/ChevronLeft';
import Nav from 'react-bootstrap/Nav';
import NavDropdown from 'react-bootstrap/NavDropdown';
import actionsApp from '~/redux/app/actions';
import actionsCommon from '~/redux/common/actions';

import isDisplayHeadbandOrder from '~/src/lib/isDisplayHeadbandOrder';
import getPageSlug from '~/src/lib/getPageSlug';
import SpecialDate from './SpecialDate';
import MultiSort from 'multi-sort';
import getFilteredOrders from '~/src/lib/getFilteredOrders';
import {
    HEADER_MAX,
    HEADER_MIN,
    HEADER_BG,
    HEADER_BG1,
    HEADER_COLOR,
    HEADER_COLOR1,
} from '~/src/config/constants';

import { DateTime, Settings } from 'luxon';

import SeeTodayOrderButton from '~/src/components/Order/SeeTodayOrderButton';

import dynamic from 'next/dynamic';
import translateMsg from '~/src/lib/translateMsg';
import getHeaderSpecialInfoHeight from '~/src/lib/getHeaderSpecialInfoHeight';
import config from '~/src/config';
import brightnessColor from '~/src/lib/common/utils/brightnessColor';
import FontMc23 from '~/src/components/FontMc23';

import getAvailableMenus from '~/src/lib/getAvailableMenus';
import { useScreenDetector } from '~/src/hooks/useScreenDetector';
import isDisplayMenu from '~/src/lib/isDisplayMenu';

const Drawer = dynamic(() => import('../Drawer'), {
    ssr: false,
});

const FuseAnimate = dynamic(() => import('~/src/components/FuseAnimate'), {
    ssr: false,
});

const anonymousOrderDivHeight = 60;

// Hook
function useHover() {
    const [value, setValue] = useState(false);
    const ref = useRef(null);

    const handleMouseOver = () => setValue(true);
    const handleMouseOut = () => setValue(false);

    useEffect(
        () => {
            const node = ref.current;
            if (node) {
                node.addEventListener('mouseover', handleMouseOver);
                node.addEventListener('mouseout', handleMouseOut);

                return () => {
                    node.removeEventListener('mouseover', handleMouseOver);
                    node.removeEventListener('mouseout', handleMouseOut);
                };
            }
        },
        [ref.current], // Recall only if ref changes
    );

    return [ref, value];
}

function App(props) {
    const router = useRouter();

    const { isMobile, isTablet, isDesktop } = useScreenDetector();

    const business = useSelector((state) => state.business);
    const lang = useSelector((state) => state.lang);
    const cart = useSelector((state) => state.common.cart);
    const selectedMenu = useSelector((state) => state.common.selectedMenu);
    const user = useSelector((state) => state.user);
    const orders = useSelector((state) => state.order);
    const todayTableOrder = getFilteredOrders(orders, {
        today: true,
        type: 'inside',
        status: 'not_delivered',
    });
    const takeawayOrder = getFilteredOrders(orders, {
        type: 'takeaway',
        status: 'not_delivered',
    });
    const todayOrder = getFilteredOrders(orders, {
        today: true,
        status: 'not_delivered',
    });

    const menuType = useSelector((state) => state.common.menuType);

    const [currentPos, setCurrentPos] = useState(0);
    const [hoverRef, isHovered] = useHover();

    const dispatch = useDispatch();

    useScrollPosition(
        ({ prevPos, currPos }) => {
            const isVisible = currPos.y > -20;

            let height = isVisible ? HEADER_MAX : HEADER_MIN;

            if (currPos.y > 0) {
                return false;
            }

            const ttt =
                document.body.scrollHeight -
                window.innerHeight -
                window.scrollY;

            if (ttt < 0) {
                return false;
            }

            setCurrentPos(currPos.y);
        },
        [isHovered],
    );

    const _isHome = () => {
        if (router.pathname === '/') {
            return true;
        }

        return false;
    };

    const _onBack = (event) => {
        event.preventDefault();
        /*
    if (document.location.pathname === "/payment_success") {
      _redirect("/");
      return;
    }
    */

        if (router && router.pathname && router.pathname === '/checkout') {
            //https://trello.com/c/vK0vfIoI/5224-routeur-nextjs-vs-back-navigateur
            router.back();
            /*
            if (cart && cart.products && cart.products.length === 0) {
                if (menuType === 'inside') {
                    _redirect('/account/orders/todayUnpaidTableOrder');
                } else {
                    _redirect('/account/orders/takeawayOrderNotDelivered');
                }
            } 
            */
        } else {
            //alert(1);
            console.log('router.back');
            console.log(router);

            try {
                router.isReady = true;
                router.back();
            } catch (err) {
                console.log('error back');
                document.location.href = '/';
            }
        }
    };

    const _redirect = (item) => {
        console.log('_redirect');
        console.log(item);
        const k = '/' + lang + item;
        console.log(k);

        router.push(k, k, { locale: lang });
    };

    const _getColorText = (t) => {
        if (router.pathname === t) {
            return business.info.header_color_a_s;
        }

        return business.info.header_color_i_s;
    };

    const _getColor = () => {
        return business.info.header_color_i_s;
    };

    const _getColorIcon = () => {
        return business.info.header_icon_s;
    };

    const _getColorIconHover = () => {
        return business.info.header_color_h_s;
    };

    const _getColorIconHover1 = () => {
        return business.info.header_color_h;
    };

    const _getColorHover = () => {
        return business.info.header_color_h_s;
    };

    const _getBackgroundColor = (item) => {
        if (currentPos === 0) {
            return business.info.header_bg;
        }
        return business.info.header_bg_s;
    };

    const _getName = (item) => {
        if (item.business_page_id) {
            //console.log(item);
            //console.log(business.pages);

            const match = business.pages.find(
                (o) => o.id === item.business_page_id,
            );

            if (match) {
                return match.name.val;
            } else {
                return false;
            }
        }

        if (item.name === 'contact') {
            return translateMsg('webapp', 'pwa_ui__contact');
        }
        return item.name;
    };

    const _onclick = (eventKey) => {
        const item = business.headerItems.find((o) => o.id == eventKey);

        if (item) {
            if (item.business_page_id) {
                const match = business.pages.find(
                    (o) => o.id === item.business_page_id,
                );

                if (match) {
                    if (match.type === 'url') {
                        window.open(match.url, '_blank');
                    }

                    const slug = getPageSlug(match.name.val);

                    if (['html', 'froala'].includes(match.type)) {
                        router.push(
                            `/page/${match.uuid}/${slug}`,
                            `/page/${match.uuid}/${slug}`,
                            {
                                locale: lang,
                            },
                        );
                    }
                }
            } else if (item.name === 'contact') {
                _redirect('/contact');
            }
        }
    };

    const _displayItemMenu = () => {
        const menus = getAvailableMenus(business?.menusV2, user, lang);

        MultiSort(menus, {
            position: 'ASC',
        });

        //console.log(3333);
        //console.log(selectedMenu);
        //console.log(router.pathname);
        let title = translateMsg(
            'webapp',
            `pwa_ui__${business.info.label_website_tab}`,
        );

        const match = business.menusV2.find((o) => o.id === selectedMenu);

        //console.log('RRRRRRRR');
        //console.log(match);

        if (router.pathname === '/m/[slug]' && match && match.title) {
            title = `${title} - ${match.title}`;
        }

        return (
            <>
                <style type="text/css">
                    {`
                #nav-dropdown {
                    color: ${_getColorText('/m/[slug]')};
                    background-color: transparent;
                }
                #nav-dropdown:hover {
                    color: ${_getColor()};
                    
                }

                .dropdown-menu {
                    z-index: 9999;
                    background-color: ${_getBackgroundColor()};
                }


                .dropdown-menu .dropdown-item{
                    color: ${_getColor()} !important;
                }

                .dropdown-menu .dropdown-item:hover{
                    background-color: ${business.info.header_bgm};
                    color: ${_getColorIconHover1()} !important;
                }
                
          
                `}
                </style>
                <NavDropdown title={title} id="nav-dropdown" style={{}}>
                    {menus.map((menu) => {
                        return (
                            <NavDropdown.Item
                                key={menu.id}
                                eventKey={menu.id}
                                onClick={(event) => {
                                    event.preventDefault();
                                    setTimeout(() => {
                                        router.push(
                                            `/${lang}/m/${menu.slug}`,
                                            `/${lang}/m/${menu.slug}`,
                                            {
                                                locale: lang,
                                            },
                                        );
                                        window.scrollTo(0, 0);
                                    }, 300);
                                }}
                                style={
                                    {
                                        //color: _getColor()
                                    }
                                }
                            >
                                {menu.title}
                            </NavDropdown.Item>
                        );
                    })}
                </NavDropdown>
            </>
        );
    };

    const _getPagesLeft = () => {
        if (window.innerWidth < 992) {
            return false;
        }

        return (
            <>
                <style type="text/css">
                    {`
                    .nav-link:hover {
                        color: ${_getColorHover()} !important;
                        transition: color 500ms ease 0s, fill 500ms ease 0s;
                    }    
                `}
                </style>
                <div
                    style={{
                        display: 'flex',
                        //flexDirection: +business.info.header_center ? 'column' : 'row-reverse',
                        alignItems: 'flex-start',
                        //border: '1px solid blue',
                        width: '100%',
                        flex: 1,
                        alignItems: 'center',
                        //border: '1px solid blue'
                    }}
                >
                    <Nav variant="pills" activeKey="1" onSelect={_onclick}>
                        {business.headerItems &&
                            business.headerItems.map((item, index) => {
                                if (
                                    item.name === 'contact' &&
                                    +business.info.contact_form === 0
                                ) {
                                    return false;
                                }

                                const header_title = `header_title_${item.id}`;

                                if (
                                    typeof item.business_page_id !== 'number' &&
                                    item.name === 'menu'
                                ) {
                                    const menus = business.menusV2.filter(
                                        (o) =>
                                            ['website', 'pdf'].includes(
                                                o.type,
                                            ) &&
                                            o.active === 1 &&
                                            isDisplayMenu(o, user, lang) ===
                                                true,
                                    );
                                    if (menus.length === 1) {
                                        return (
                                            <Nav.Item
                                                className={header_title}
                                                key={index}
                                            >
                                                <div
                                                    onClick={(event) => {
                                                        event.preventDefault();
                                                        dispatch(
                                                            actionsCommon.setSelectedMenu(
                                                                menus[0].id,
                                                            ),
                                                        );

                                                        setTimeout(() => {
                                                            router.push(
                                                                `/m/${menus[0].slug}`,
                                                                `/m/${menus[0].slug}`,
                                                                {
                                                                    locale: lang,
                                                                },
                                                            );
                                                            window.scrollTo(
                                                                0,
                                                                0,
                                                            );
                                                        }, 300);
                                                    }}
                                                    className="nav-link"
                                                    style={{
                                                        color: _getColorText(
                                                            '/m/[slug]',
                                                        ),
                                                        cursor: 'pointer',
                                                    }}
                                                >
                                                    {translateMsg(
                                                        'webapp',
                                                        `pwa_ui__${business.info.label_website_tab}`,
                                                    )}
                                                </div>
                                            </Nav.Item>
                                        );
                                    }

                                    return _displayItemMenu();
                                }
                            })}
                    </Nav>
                </div>
            </>
        );
    };

    const _getPagesRight = () => {
        if (window.innerWidth < 992) {
            return false;
        }

        return (
            <>
                <div
                    style={{
                        display: 'flex',
                        //flexDirection: +business.info.header_center ? 'column' : 'row-reverse',
                        alignItems: 'flex-start',
                        //border: '1px solid blue',
                        //width: "100%",
                        //flex: 1,
                        alignItems: 'center',
                        //border: '1px solid blue'
                    }}
                >
                    <Nav variant="pills" activeKey="1" onSelect={_onclick}>
                        {business.headerItems &&
                            business.headerItems.map((item, index) => {
                                if (
                                    item.name === 'contact' &&
                                    +business.info.contact_form === 0
                                ) {
                                    return false;
                                }

                                if (
                                    typeof item.business_page_id !== 'number' &&
                                    item.name === 'menu'
                                ) {
                                    return false;
                                }

                                if (typeof item.business_page_id !== 'number') {
                                    const header_title = `header_title_${item.id}`;

                                    return (
                                        <Nav.Item
                                            key={item.id}
                                            className={header_title}
                                        >
                                            <Nav.Link
                                                eventKey={item.id}
                                                title={_getName(item)}
                                                style={{
                                                    color: _getColorText(
                                                        `/${_getName(item)}`,
                                                    ),
                                                }}
                                            >
                                                {_getName(item)}
                                            </Nav.Link>
                                        </Nav.Item>
                                    );
                                }

                                if (typeof item.business_page_id === 'number') {
                                    const header_title = `header_title_${item.business_page_id}`;
                                    return (
                                        <Nav.Item
                                            key={item.id}
                                            className={header_title}
                                        >
                                            <Nav.Link
                                                eventKey={item.id}
                                                title={_getName(item)}
                                                style={{
                                                    color: _getColorText(
                                                        `/${item.name}`,
                                                    ),
                                                }}
                                            >
                                                {_getName(item)}
                                            </Nav.Link>
                                        </Nav.Item>
                                    );
                                }
                            })}
                    </Nav>
                </div>
            </>
        );
    };

    const _getCart = () => {
        let nbProducts = getCartNbProducts(cart);

        if (nbProducts === 0) {
            return false;
        }

        return (
            <div
                className="header_cart"
                style={{ marginRight: 10 }}
                onClick={(event) => {
                    event.preventDefault();
                    router.push('/cart', '/cart', { locale: lang });
                }}
            >
                <FuseAnimate
                    animation="transition.expandIn"
                    nbProducts={nbProducts}
                >
                    <ShoppingBasket
                        business={business}
                        nb={nbProducts}
                        color={_getColorIcon()}
                    />
                </FuseAnimate>
            </div>
        );
    };

    const _getSocial = () => {
        if (!business.social) {
            return false;
        }

        if (business.social.length === 0) {
            return false;
        }

        if (isMobile === true) {
            return false;
        }

        return (
            <div>
                {business.social.map((social, index) => {
                    if (typeof social.url !== 'string') {
                        return false;
                    }

                    if (social.url.length < 10) {
                        return false;
                    }

                    if (+social.active === 0) {
                        return false;
                    }

                    if (+social.active_header === 0) {
                        return false;
                    }

                    const brightnessByColor = brightnessColor(
                        business.info.custom_bg3
                            ? business.info.custom_bg3
                            : '#000000',
                    );
                    let color = '#FFFFFF';

                    if (brightnessByColor > 122) {
                        color = '#000000';
                    }

                    return (
                        <IconButton
                            key={index}
                            onClick={(event) => {
                                event.preventDefault();
                                window.open(social.url, '_blank');
                            }}
                            aria-label="instagram"
                        >
                            {/*
                            <FontMc23
                                simple={true}
                                code={social.unicode}
                                color={business.info.header_icon}
                                size={25}
                            />
                        */}

                            <div
                                style={{
                                    //marginRight: 10,
                                    fill: _getColorIcon(),
                                    //transform: 'scale(1.3)',
                                    width: 25,
                                }}
                                dangerouslySetInnerHTML={{
                                    __html: social.code,
                                }}
                            ></div>
                        </IconButton>
                    );

                    if (social.name === 'instagram') {
                        return (
                            <IconButton
                                key={index}
                                onClick={(event) => {
                                    event.preventDefault();
                                    window.open(social.url, '_blank');
                                }}
                                aria-label="instagram"
                            >
                                <InstagramIcon
                                    style={{ color: _getColorIcon() }}
                                />
                            </IconButton>
                        );
                    }

                    if (social.name === 'Facebook') {
                        return (
                            <IconButton
                                key={index}
                                onClick={(event) => {
                                    event.preventDefault();
                                    window.open(social.url, '_blank');
                                }}
                                aria-label="Facebook"
                            >
                                <FacebookIcon
                                    style={{ color: _getColorIcon() }}
                                />
                            </IconButton>
                        );
                    }
                })}
            </div>
        );
    };

    const _getLogo = () => {
        if (+business.info.header_logo === 1 && business.info.logo) {
            if (
                +business.info.header_logo_hide_wns === 1 &&
                router.route === '/'
            ) {
                if (currentPos === 0) {
                    return false;
                }
            }

            const url = `${config.specificAssetsUrl}/logo/${business.info.logo}`;
            return (
                <img
                    className="header_logo"
                    onClick={(event) => {
                        event.preventDefault();
                        router.push(`/${lang}`, `/${lang}`, { locale: lang });
                    }}
                    src={url}
                    style={{
                        height: HEADER_MIN - 10,
                        paddingTop: 5,
                        paddingBottom: 5,
                        cursor: 'pointer',
                        boxSizing: 'content-box',
                        //width: 100,
                    }}
                />
            );
        }

        return (
            <a
                className="header_logo_title"
                onClick={(event) => {
                    event.preventDefault();
                    router.push(`/${lang}`, `/${lang}`, { locale: lang });
                }}
                style={{
                    textDecoration: 'none',
                    color: 'inherit',
                    display: 'flex',
                }}
            >
                <Text
                    style={{
                        cursor: 'pointer',
                        color: _getColor(),
                        alignSelf: 'center',

                        fontWeight: 'bold',
                        fontSize: '1em',
                    }}
                    variant="h6"
                >
                    {business.info.name}
                </Text>
            </a>
        );
    };

    const _displayHeadbandOrder = () => {
        if (isDisplayHeadbandOrder(business, orders, router) === false) {
            return false;
        }

        return (
            <div
                style={{
                    height: isMobile ? 'auto' : anonymousOrderDivHeight,
                    cursor: 'pointer',
                    display: 'flex',
                    flexDirection: 'row',
                    alignSelf: 'center',
                    alignItems: 'center',
                    justifyContent: 'center',
                    //position: "fixed",
                    //top: top,
                    //left: 0,
                    //zIndex: 1203,
                    backgroundColor: '#000000',
                    width: '100%',
                    padding: 5,
                }}
            >
                <SeeTodayOrderButton
                    todayTableOrder={todayTableOrder}
                    takeawayOrder={takeawayOrder}
                />
            </div>
        );
    };

    if (typeof window === 'undefined') {
        return <div></div>;
    }

    if (!business) {
        return false;
    }
    if (!business.info) {
        return false;
    }

    return (
        <>
            <style type="text/css">
                {`
                    .nav-link:hover {
                        color: ${_getColorHover()} !important;
                        transition: color 500ms ease 0s, fill 500ms ease 0s;
                    }    

                `}
            </style>
            <style type="text/css">
                {`
                #header .MuiSvgIcon-root:hover {
                    color: ${_getColorIconHover()} !important;
                }
                

                #container-homebloc-0 .container-homebloc {
                    padding-top: ${HEADER_MIN}px;
                  
                }

                #container-homebloc-0 .container-homebloc[data-type="image"] {
                    padding-top: 0px !important;
                }
                #container-homebloc-0 .container-homebloc[data-type="splitimage"] {
                    padding-top: 0px !important;
                }

                #container-homebloc-0 .container-homebloc[data-type="fixedimage"] {
                    padding-top: 0px !important;
                }



                /*
                .container-homebloc:nth-of-type(1)[data-type="html"] {
                    padding-top: ${HEADER_MIN}px !important;
                }
                .container-homebloc:nth-of-type(1)[data-type="code"] {
                    padding-top: ${HEADER_MIN}px !important;
                }
                .container-homebloc:nth-of-type(1)[data-type="froala"] {
                    padding-top: ${HEADER_MIN}px !important;
                }
                .container-homebloc:nth-of-type(1)[data-type="video"] {
                    padding-top: ${HEADER_MIN}px !important;
                }
                */
            `}
            </style>

            <div
                ref={hoverRef}
                style={{
                    position: 'sticky',
                    top: 0,
                    zIndex: 1202,
                }}
            >
                <SpecialDate />
                {_displayHeadbandOrder()}

                <header
                    id="headerInner"
                    style={{
                        //...headerStyle,
                        height: HEADER_MIN,
                        backgroundColor: _getBackgroundColor(),
                        boxShadow: business.info.header_shadow_s,
                        position: 'relative',
                        width: '100%',
                        //zIndex: 1202,
                        display: 'flex',
                        alignItems: 'center',
                        flexWrap: 'nowrap',
                        //boxPack: "justify",
                        //backfaceVisibility: "hidden",
                        //perspective: 1000,
                    }}
                >
                    <div
                        style={{
                            display: 'flex',
                            boxPack: 'start',
                            justifyContent: 'flex-start',
                            flexWrap: 'nowrap',

                            flex: 1,
                            maxWidth: '30%',
                            //border: '1px solid red'
                        }}
                    >
                        {typeof document !== 'undefined' &&
                            document.location &&
                            document.location.pathname &&
                            document.location.pathname.length > 3 && (
                                <ChevronIcon
                                    onClick={_onBack}
                                    style={{
                                        cursor: 'pointer',
                                        color: _getColorIcon(),
                                        fontSize: 36,
                                    }}
                                />
                            )}

                        {_getPagesLeft()}
                    </div>
                    <div
                        style={{
                            //position: "absolute",
                            //top: top,
                            //left: "50%",

                            //transform: "translateX(-50%)",
                            height: '100%',
                            display: 'flex',
                            boxPack: 'center',
                            justifyContent: 'center',
                            flex: 1,
                            maxWidth: '33%',
                            //alignItems: 'flex-end'

                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'center',
                        }}
                    >
                        {_getLogo()}
                    </div>
                    <div
                        style={{
                            display: 'flex',
                            boxPack: 'end',
                            justifyContent: 'flex-end',
                            paddingRight: 5,
                            flex: 1,
                            //maxWidth: "30%",
                            //padding: '0px 5vw 0px 0px'
                        }}
                    >
                        {_getPagesRight()}
                        {_getSocial()}
                        {_getCart()}
                        <Drawer
                            iconColor={_getColorIcon()}
                            color={business.info.header_color_i_s}
                            backgroundColor={business.info.header_bg_s}
                            colorHover={_getColorIconHover1()}
                            bgm={business.info.header_bgm}
                        />
                    </div>
                </header>
            </div>
        </>
    );
}

export default App;
